export enum RequestStatusEnum {
  PENDING = 'pending',
  ACTIVE = 'active',
  CANCELED = 'canceled',
  COMPLETED = 'completed',
  PROOFING = 'proofing',
  REROLLED = 'rerolled',
}
